import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PersonalService } from '../../../services/personal.service';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { ErroresService } from '../../../core/services/errores.service';
import { ConfigDataService } from 'app/services/config-data.service';
import { SubSedeService } from '../../../services/subSede.service';

@Component({
  selector: 'app-personal-list',
  templateUrl: './personal-list.component.html',
  styleUrls: ['./personal-list.component.css'],
  providers: [MessageService, ConfirmationService]
})
export class PersonalListComponent implements OnInit {

  tituloTabla: string = "Personal";
  empleados: any[];
  MensajeError: string;
  showDetails:boolean = false;
  
  gruposLiquidacionList: any;
  sociedadesList: any;
  sedesList: any;
  subsedesList: any;

  invalida: boolean;
  rowsExport: any;
  permisoEdicion: boolean = false;

  constructor(private formuBuilder: FormBuilder,
              private personalService: PersonalService, 
              private router: Router,
              private configDataSrv: ConfigDataService,
              private erroresService: ErroresService,
              private subSedeSrv: SubSedeService) { }

  ngOnInit(): void
  {
    this.configDataSrv.GetCombosInfoDatosOrganizativos().subscribe(
      data => {
        this.sociedadesList=data["Sociedades"];
        this.sedesList=data["Sedes"];
        this.gruposLiquidacionList=data["GruposLiquidacion"];
      }
    );

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Gestion Persona Sociedad")) this.permisoEdicion = true;
  }

  abrirDetalle(row, index: number)
  {
    this.router.navigate(['gestionar', {legajo: row.legajo}]);
  }

  registerForm = this.formuBuilder.group({
    sociedad: [''],
    sede: [''],
    subSede: [''],
    grupoLiq: [''],
    legajo: ['', Validators.pattern(/^[+]*[0-9]{1,8}[0-9]*$/)]
  });

  get registerFormControl()
  {
    return this.registerForm.controls;
  }

  onSubmit(){}

  verResultados(): void 
  {
    this.showDetails = false;
    let filtros = this.registerForm.value;
    
    this.showDetails = true;
    this.personalService.getListFiltros(Number(filtros.legajo), Number(filtros.sociedad), Number(filtros.sede), Number(filtros.subSede), Number(filtros.grupoLiq), false).subscribe(
      data => {
        this.empleados = data;
        this.rowsExport = data.map(function(obj) {
          return {
            legajo: obj.legajo,
            nombre: obj.nombre,
            apellido: obj.apellido,
            grupoLiquidacion: obj.datosOrganizativos[0].grupoLiquidacionNavigation.codigo,
            sociedad: obj.datosOrganizativos[0].sociedadNavigation.descripcion,
            sede: obj.datosOrganizativos[0].sedeNavigation.descripcion,
            subSede: obj.datosOrganizativos[0].subSedeNavigation.descripcion
          }
        });
    });
  }

  onChangeSede(event) {
    this.registerForm.controls['subSede'].setValue(null);
    this.cargarSubSedes(event.value);    
  }

  cargarSubSedes(sede:number){
    if (sede != null) {
      this.subSedeSrv.getSubSedes(sede).subscribe(data => { this.subsedesList = data })
    }
  }
}
